const initialState ={
  current_workspace_id:localStorage.getItem('current_workspace_id'),
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'REQUEST_LOGOUT_SUCCESS':
    case 'SWITCH_WORKSPACE':
      localStorage.removeItem('current_workspace_id', undefined);
      window.location.href='/workspaces/switch';
      newState.current_workspace_id=undefined;
      newState.data=undefined;
      break;
    case 'REQUEST_USER_WORKSPACE_SUCCESS':
      newState.data[action.val.workspace_id].user_workspaces[action.val.id]={...newState.data[action.val.workspace_id].user_workspaces[action.val.id], ...action.val}
      newState.data[action.val.workspace_id].all_user_workspaces[action.val.id]={...newState.data[action.val.workspace_id].all_user_workspaces[action.val.id], ...action.val}
      newState.refresh=newState.refresh+1;
      break;
    case 'REQUEST_CREATE_SMS_LOGIN_SUCCESS':
    case 'REQUEST_UPDATE_SMS_LOGIN_SUCCESS':
    case 'REQUEST_DELETE_SMS_LOGIN_SUCCESS':
      window.location.reload();
    break;
    case 'REQUEST_INDEX_WORKSPACES_SUCCESS':
      if(newState.data==undefined){newState.data={}}
      for(let w of action.val){if(newState.data[w.id]!=undefined){newState.data[w.id]={...newState.data[w.id], ...w}}else{newState.data[w.id]=w}}
      break;
    case 'REQUEST_CREATE_WORKSPACE_SUCCESS':
    case 'REQUEST_GET_CURRENT_WORKSPACE_SUCCESS':
      if(action.val.error==true){
        console.log('ERRRRRROOOOOORRR');
        localStorage.removeItem('current_workspace_id');
        newState.current_workspace_id=undefined;
        window.location.reload();
      }else{
        if(newState.data==undefined){newState.data={}}
        newState.data[action.val.id]=action.val;
        let user_workspaces={}
        let all_user_workspaces={}
        if(action.val.user_workspaces!=undefined){for(let u of action.val.user_workspaces){if(u.user_id!=undefined){user_workspaces[u.id]=u;} all_user_workspaces[u.id]=u;}}
        newState.data[action.val.id].all_user_workspaces=all_user_workspaces;
        newState.data[action.val.id].user_workspaces=user_workspaces;
        newState.current_workspace_id=action.val.id;
        localStorage.setItem('current_workspace_id', action.val.id);
        newState.refresh=newState.refresh+1;
        if(action.type=='REQUEST_CREATE_WORKSPACE_SUCCESS'){window.location.href='/home';}
        else if(action.val.redirect_to!=undefined){window.location.href=action.val.redirect_to;}
      }
      break;
    case 'REQUEST_UPDATE_WORKSPACE_SUCCESS':
      newState.data[action.val.id].name=action.val.name;
      newState.data[action.val.id].workspace_email_bcc=action.val.workspace_email_bcc;
      newState.data[action.val.id].scrape_websites=action.val.scrape_websites;
      newState.data[action.val.id].domain_default_deduplication=action.val.domain_default_deduplication;
      newState.data[action.val.id].company_name_deduplication=action.val.company_name_deduplication;
      newState.data[action.val.id].email_phone_deduplication=action.val.email_phone_deduplication;
      newState.data[action.val.id].longitude_latitude_deduplication=action.val.longitude_latitude_deduplication;
      newState.data[action.val.id].longitude_latitude_wide_deduplication=action.val.longitude_latitude_wide_deduplication;
      newState.data[action.val.id].unassigned_public=action.val.unassigned_public;
      newState.data[action.val.id].currency=action.val.currency;
      newState.data[action.val.id].unsubscribe_button_default_on=action.val.unsubscribe_button_default_on;
      newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_WORKSPACE_TOGGLE_SWITCH_SUCCESS':
      console.log('AUTO LINK', action.val);
      newState.data[action.val.workspace_id].links_toggle_switch=action.val.links_toggle_switch;
      newState.data[action.val.workspace_id].auto_link_outside_popup=action.val.auto_link_outside_popup;
      newState.data[action.val.workspace_id].auto_link=action.val.auto_link;
      break;
    case 'REQUEST_CREATE_WORKSPACE_LISTING_WEBSITE_SUCCESS':
    case 'REQUEST_UPDATE_WORKSPACE_LISTING_WEBSITE_SUCCESS':
      if(newState.data==undefined){newState.data={}}
      if(newState.data[action.val.workspace_id]==undefined){newState.data[action.val.workspace_id]={}}
      if(action.val.search_tools!=undefined){newState.data[action.val.workspace_id].search_tools=action.val.search_tools;}
      else{
        let workspace_listing_websites=[]; let done_wlw=false; for(let l of newState.data[action.val.workspace_id].workspace_listing_websites){if(l.id==action.val.id){workspace_listing_websites.push(action.val); done_wlw=true;}else{workspace_listing_websites.push(l);}} if(done_wlw==false){workspace_listing_websites.push(action.val);}
        newState.data[action.val.workspace_id].workspace_listing_websites=workspace_listing_websites;
      }
      newState.refresh=newState.refresh+1;
      break;
    case 'REQUEST_CREATE_WORKSPACE_LINK_LISTENER_SUCCESS':
    case 'REQUEST_UPDATE_WORKSPACE_LINK_LISTENER_SUCCESS':
          if(newState.data==undefined){newState.data={}}
          if(newState.data[action.val.workspace_id]==undefined){newState.data[action.val.workspace_id]={}}
          let workspace_link_listeners=[]; let done=false; for(let l of newState.data[action.val.workspace_id].workspace_link_listeners){if(l.id==action.val.id){workspace_link_listeners.push(action.val); done=true;}else{workspace_link_listeners.push(l);}} if(done==false){workspace_link_listeners.push(action.val);}
          newState.data[action.val.workspace_id].workspace_link_listeners=workspace_link_listeners;
          newState.refresh=newState.refresh+1;
          break;
    case 'REQUEST_DELETE_WORKSPACE_LINK_LISTENER_SUCCESS':
          if(newState.data!=undefined && newState.data[action.val.workspace_id]!=undefined){
          let workspace_link_listeners=[]; for(let l of newState.data[action.val.workspace_id].workspace_link_listeners){if(l.id!=action.val.id){workspace_link_listeners.push(l);}}
          newState.data[action.val.workspace_id].workspace_link_listeners=workspace_link_listeners;
          newState.refresh=newState.refresh+1;
        }
      break;
    case 'REQUEST_CREATE_WORKSPACE_STRING_LISTENER_SUCCESS':
    case 'REQUEST_UPDATE_WORKSPACE_STRING_LISTENER_SUCCESS':
      if(newState.data==undefined){newState.data={}}
      if(newState.data[action.val.workspace_id]==undefined){newState.data[action.val.workspace_id]={}}
      let workspace_string_listeners=[]; let done_string_listener=false; for(let l of newState.data[action.val.workspace_id].workspace_string_listeners){if(l.id==action.val.id){workspace_string_listeners.push(action.val); done_string_listener=true;}else{workspace_string_listeners.push(l);}} if(done_string_listener==false){workspace_string_listeners.push(action.val);}
      newState.data[action.val.workspace_id].workspace_string_listeners=workspace_string_listeners;
      newState.refresh=newState.refresh+1;
      break;
    case 'REQUEST_DELETE_WORKSPACE_STRING_LISTENER_SUCCESS':
          if(newState.data!=undefined && newState.data[action.val.workspace_id]!=undefined){
          let workspace_string_listeners=[]; for(let l of newState.data[action.val.workspace_id].workspace_string_listeners){if(l.id!=action.val.id){workspace_string_listeners.push(l);}}
          newState.data[action.val.workspace_id].workspace_string_listeners=workspace_string_listeners;
          newState.refresh=newState.refresh+1;
          }
      break;
  case 'REQUEST_DELETE_WORKSPACE_LISTING_WEBSITE_SUCCESS':
        if(newState.data!=undefined && newState.data[action.val.workspace_id]!=undefined){
        if(action.val.search_tools!=undefined){newState.data[action.val.workspace_id].search_tools=action.val.search_tools;}
        else{
          let workspace_listing_websites=[]; for(let l of newState.data[action.val.workspace_id].workspace_listing_websites){if(l.id!=action.val.id){workspace_listing_websites.push(l);}}
          newState.data[action.val.workspace_id].workspace_listing_websites=workspace_listing_websites;
        }
        newState.refresh=newState.refresh+1;
        }
    break;
   case 'REQUEST_UPDATE_EXTERNAL_CRM_OWNERS_SUCCESS':
      window.location.reload();
      newState.refresh+=1;
    break;
    case 'REQUEST_UPDATE_HUBSPOT_CALL_DISPOSITIONS_SUCCESS':
      let new_crms=[];
      for(let crm_login of newState.data[newState.current_workspace_id].crm_logins){
        if(action.val.hubspot_call_dispositions!=undefined && action.val.hubspot_call_dispositions.crm_login_id==crm_login.id){
          crm_login.hubspot_call_dispositions=action.val.hubspot_call_dispositions;
        }
        new_crms.push(crm_login);
      }
       newState.data[newState.current_workspace_id].crm_logins=new_crms;
       newState.refresh+=1;
    break;
    case 'REQUEST_UPDATE_EXTERNAL_CRM_SETUP_SUCCESS':
      newState.data[newState.current_workspace_id].crm_logins=action.val;
      newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_WORKSPACE_FIELDS_SUCCESS':
      newState.data[action.val.id].workspace_fields=action.val.workspace_fields; newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_WORKSPACE_FIELD_SUCCESS':
    case 'REQUEST_CREATE_WORKSPACE_FIELD_SUCCESS':
      newState.data[action.val.id].workspace_fields=action.val.workspace_fields; newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_WORKSPACE_DECISIONS_SUCCESS':
      newState.data[action.val.id].workspace_decisions=action.val.workspace_decisions; newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_WORKSPACE_FIELD_SUCCESS':
      let n=[]; for(let wf of newState.data[newState.current_workspace_id].workspace_fields){if(wf.id!=action.val.id){n.push(wf);}}
      newState.data[newState.current_workspace_id].workspace_fields=n; newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_WORKSPACE_DECISION_SUCCESS':
      let n2=[]; for(let wd of newState.data[newState.current_workspace_id].workspace_decisions){if(wd.id!=action.val.id){n2.push(wd);}}
      newState.data[newState.current_workspace_id].workspace_decisions=n2; newState.refresh+=1;
      break;
    case 'REQUEST_MERGE_WORKSPACE_FIELDS_SUCCESS':
      let n3=[]; for(let wf of newState.data[newState.current_workspace_id].workspace_fields){if(wd.id!=action.val.from_id){n3.push(wf);}}
      newState.data[newState.current_workspace_id].workspace_fields=n3; newState.refresh+=1;
      break;
    case 'REQUEST_MERGE_WORKSPACE_DECISIONS_SUCCESS':
      let n4=[]; for(let wd of newState.data[newState.current_workspace_id].workspace_decisions){if(wd.id!=action.val.from_id){n4.push(wd);}}
      newState.data[newState.current_workspace_id].workspace_decisions=n4; newState.refresh+=1;
      break;
    case 'REQUEST_UPDATE_TEAM_MEMBER_SUCCESS':
    case 'REQUEST_CREATE_TEAM_MEMBER_SUCCESS':
      window.location.href='/team';
      break;
    case 'REQUEST_DELETE_TEAM_MEMBER':
      window.location.href='/team';
      break;
    case 'REQUEST_UPDATE_CREDITS_DISTRIBUTION_SUCCESS':
      for(let uw of action.val.user_workspaces){newState.data[newState.current_workspace_id].user_workspaces[uw.id]=uw;}
      newState.refresh=newState.refresh+1;
      break;
    case 'REQUEST_UPDATE_SEARCH_TOOLS_SUCCESS':
      if(newState.data!=undefined && newState.data[action.val.workspace_id]!=undefined){
        if(action.val.search_tools!=undefined){newState.data[action.val.workspace_id].search_tools=action.val.search_tools;}
        if(action.val.workspace_listing_websites!=undefined){newState.data[action.val.workspace_id].workspace_listing_websites=action.val.workspace_listing_websites;}
        newState.refresh=newState.refresh+1;
      }
      break;
    }
  return newState;
}

export default reducer;
